/**
 * Forum classes are now loaded from Firebase (getClassesForForum).
 * Admin seeds them once via "Seed forum classes" in the Classes tab.
 */

/** School ID used by the backend for this app (American School). */
export const FORUM_SCHOOL_ID = "school_demo";

/** Options for the "Escuela" (current school) dropdown. American School is the main option; "other" shows a free-text input. */
export const FORUM_SCHOOL_OPTIONS = [
  { id: FORUM_SCHOOL_ID, name: "American School" },
  { id: "other", name: "Otra" },
] as const;

export const SCHOOL_AGES = Array.from({ length: 16 }, (_, i) => i + 3); // 3 to 18

export const RELATIONSHIPS = [
  { es: "Madre", en: "Mother" },
  { es: "Padre", en: "Father" },
  { es: "Abuela", en: "Grandmother" },
  { es: "Abuelo", en: "Grandfather" },
  { es: "Tía", en: "Aunt" },
  { es: "Tío", en: "Uncle" },
  { es: "Niñera", en: "Nanny" },
  { es: "Madrastra", en: "Step-mother" },
  { es: "Padrastro", en: "Step-father" },
  { es: "Otro", en: "Other" },
];
